
import { useState, useEffect } from "react";

const LocationExpansion = () => {
  const [currentNumber, setCurrentNumber] = useState(15);
  const targetNumber = 100;

  useEffect(() => {
    const duration = 2000; // 2 seconds
    const increment = (targetNumber - 15) / (duration / 50);
    
    const timer = setInterval(() => {
      setCurrentNumber(prev => {
        if (prev >= targetNumber) {
          clearInterval(timer);
          return targetNumber;
        }
        return Math.min(prev + increment, targetNumber);
      });
    }, 50);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="py-32 bg-juv-soft-blush/20">
      <div className="container mx-auto px-6 max-w-6xl">
        <div className="text-center">
          <h2 className="text-5xl md:text-6xl font-serif font-light text-juv-deep-chestnut mb-12">
            Nationwide Expansion
          </h2>
          
          <div className="flex items-center justify-center space-x-8 mb-12">
            <div className="text-center">
              <div className="text-6xl md:text-8xl font-bold text-juv-terracotta mb-2">
                15
              </div>
              <p className="text-juv-deep-chestnut/70">Current Locations</p>
            </div>
            
            <div className="text-4xl text-juv-rose-clay">→</div>
            
            <div className="text-center">
              <div className="text-6xl md:text-8xl font-bold text-juv-deep-chestnut mb-2">
                {Math.floor(currentNumber)}
              </div>
              <p className="text-juv-deep-chestnut/70">Planned by 2025</p>
            </div>
          </div>
          
          <p className="text-xl text-juv-deep-chestnut/70 max-w-3xl mx-auto">
            From coast to coast, we're making aesthetic wellness accessible 
            to everyone. Find a JUV studio near you, or watch for our arrival.
          </p>
        </div>
      </div>
    </section>
  );
};

export default LocationExpansion;
